import { ReduxAction } from '@owc-types/store';
import { HeaderState } from '@owc-types/Header';
import {
  headerComponentUpdate,
  addToHeaderTracking,
  addAndSubmitTracking,
  flyoutOpen,
  flyoutClose,
  modelsFlyoutChange,
  navigationLabelsUpdate,
  actionHandlers,
} from '@owc-utils/Store/Header/actions';

const initialState: HeaderState = {
  modelsFlyoutOpen: false,
  trackingTree: [],
  headerElement: null,
  flyoutChain: [],
  navigationLabels: {},
};

export const reducer = (state: HeaderState = initialState, action: ReduxAction): HeaderState => {
  const { type, payload = {} } = action;
  switch (type) {
    case headerComponentUpdate:
      return {
        ...state,
        ...payload,
      };
    case addToHeaderTracking:
      return actionHandlers.buildingTrackingTreeForward(state, payload);
    case addAndSubmitTracking:
      return actionHandlers.buildingTrackingTreeAndSubmitting(state, payload);
    case flyoutOpen:
      return actionHandlers.openFlyoutAction(state, payload);
    case flyoutClose:
      return actionHandlers.closeFlyoutAction(state, payload);
    case modelsFlyoutChange:
      return actionHandlers.toggleModelsFlyoutAction(state, payload);
    case navigationLabelsUpdate:
      return actionHandlers.navigationLabelsUpdateAction(state, payload);
    default:
      return state;
  }
};
